const template = function(templateContent) {
    return Odigeo._.template(templateContent, Odigeo.Utils.getTmplSettings({variable: ''}));
};

module.exports = {
    template,
};
